import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from '@/App';

// ── Sentry initialization ──────────────────────────────────────────
// Only initialize if DSN is provided via environment variable.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Capture 100% of transactions for performance monitoring in dev,
    // reduce in production as needed.
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Session replay sample rate
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

// ── React mount ────────────────────────────────────────────────────
// react-snap pre-renders pages into static HTML. When the pre-rendered
// HTML is served, we hydrate instead of doing a full render to preserve
// the existing DOM and improve time-to-interactive.
const rootElement = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered by react-snap — hydrate the existing markup
  hydrateRoot(rootElement, app);
} else {
  // Normal client-side render
  createRoot(rootElement).render(app);
}
